import { useState } from "react";
import type { ToolCall } from "../types";
import "./ToolCallPanel.css";

interface Props {
  name: string;
  arguments: Record<string, unknown>;
  id?: string;
  result?: string;
}

export default function ToolCallPanel({ name, arguments: args, result }: Props) {
  const [open, setOpen] = useState(false);
  const hasResult = result !== undefined;

  return (
    <div className="tool-panel">
      <button
        className="tool-panel-header"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span className={`tool-panel-chevron ${open ? "open" : ""}`}>▸</span>
        <span className="tool-panel-icon">🛠️</span>
        <span className="tool-panel-name">{name}</span>
        {hasResult && (
          <span className={`tag ${open ? "tag-muted" : "tag-success"}`}>
            {open ? "details" : "done"}
          </span>
        )}
      </button>
      {open && (
        <div className="tool-panel-body">
          <div className="tool-section">
            <div className="tool-section-label">Arguments</div>
            <pre className="tool-pre">{JSON.stringify(args, null, 2)}</pre>
          </div>
          {hasResult && (
            <div className="tool-section">
              <div className="tool-section-label">Result</div>
              <pre className="tool-pre">{result}</pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function toolCallFromEvent(tc: {
  name: string;
  arguments: Record<string, unknown>;
  id: string;
}): ToolCall {
  return {
    id: tc.id,
    type: "function",
    function: { name: tc.name, arguments: tc.arguments },
  };
}